import api from "./axios";

class serviceAccountingFiles {
  async delete(id) {
    await api.delete(`/accounting-files/${id}`)
  }
}

export default new serviceAccountingFiles()